export const ROUTER = {
  CHANGE_LOCATION: 'upd/ROUTER_CHANGE_LOCATION',
};

export { stateGo, stateReload, stateTransitionTo } from 'redux-ui-router';

export const changeLocation = location => ({
  type: ROUTER.CHANGE_LOCATION,
  payload: { location },
});
